import { type Segment, segmentStatus } from '@openx/types/segments.ts';
import type { I18nTranslate } from '@openx/types/translations.ts';
import { MINIMUM_ESTIMATED_REACH } from '@openx/utils/services/config.ts';
import { array, number, object, string } from 'yup';

const allowedLalSeedStatuses: string[] = [segmentStatus.PUBLISHING, segmentStatus.READY];

export const validateSeedsAllowedStatus = (seeds: Array<Pick<Segment, 'status'>> | undefined) => {
  if (!seeds || seeds.length === 0) return false;

  return seeds.every(seed => (seed?.status ? allowedLalSeedStatuses.includes(seed.status.toLowerCase()) : false));
};

export const getValidationSchema = (t: I18nTranslate) =>
  object().shape(
    {
      name: string()
        .trim()
        .max(255, t('Name exceeds the maximum number of characters allowed'))
        .required(t('Name is required')),
      seeds: array()
        .required(t('Seeds are required'))
        .min(1, t('At least one seed is required'))
        .test('seeds-ready', t('Seeds must be in ready status'), validateSeedsAllowedStatus),
      estimated_reach: number()
        .min(
          MINIMUM_ESTIMATED_REACH,
          t('Estimated reach must be greater than or equal to {min}', { min: MINIMUM_ESTIMATED_REACH })
        )
        .required(t('Estimated reach is required')),
    },
    []
  );
